import * as _ from 'lodash';

export function uniqueBy<T>(array: T[], propertyName: string) {
    return _.uniqBy(array, (obj: T) => obj[propertyName]);
}
